import { ENGLISH_TRANSLATIONS, RUSSIAN_TRANSLATIONS } from './translation';

export default {
  state: {
    locale: '',
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale;
    },
  },
  getters: {
    locale(state) {
      return state.locale;
    },
    dictionary(state) {
      if (state.locale === 'ru') {
        return RUSSIAN_TRANSLATIONS;
      }
      return ENGLISH_TRANSLATIONS;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getDictionary({ commit, state }) {
      if (state.locale === 'ru') {
        return RUSSIAN_TRANSLATIONS;
      }
      return ENGLISH_TRANSLATIONS;
    },
    setLocale({ commit }, locale) {
      return commit('setLocale', locale);
    },
    // eslint-disable-next-line consistent-return
    setDefaultLocale({ commit, state }, locale) {
      if (state.locale === '') {
        return commit('setLocale', window.defaultLocale);
      }
    },
  },
};
